import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.ChangedBeneficiariesPopup',
    {
        description1:
            'The following beneficiary details were edited in Airwallex while you have been working with the request:',
        description2: 'The latest bank details from Airwallex will be applied to the request.',
        cancel: 'CANCEL',
        apply: 'APPLY',
        beneficiary: 'Beneficiary',
        discrepancy: 'Discrepancy',
    }
);
